import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './report-page.component.html';
var ReportPageComponent = (function () {
    function ReportPageComponent() {
        this.addTopSeparator = true;
        this.contentShown = false;
        this.loading = false;
        this.reported = false;
    }
    ReportPageComponent.prototype.toggleContent = function () {
        this.contentShown = !this.contentShown;
    };
    ReportPageComponent.prototype.onReported = function () {
        this.reported = true;
    };
    ReportPageComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ReportPageComponent.prototype, "addTopSeparator", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ReportPageComponent.prototype, "headline", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ReportPageComponent.prototype, "reportButtonLabel", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ReportPageComponent.prototype, "sendFeedbackButtonLabel", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ReportPageComponent.prototype, "textareaLabel", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ReportPageComponent.prototype, "spotName", void 0);
    ReportPageComponent = __decorate([
        Component({
            selector: 'reportPage',
            template: template,
            transclude: true,
        })
    ], ReportPageComponent);
    return ReportPageComponent;
}());
export { ReportPageComponent };
